import React, { useEffect } from 'react'
import withStore from '../../Components/Unstated/withStore'
import CourseContentStore from './Store/CourseContentStore'
import './CourseContent.sass'
import Lessons from './Components/Lessons'
import Loading from '../../Components/Loading/Loading'

const CourseContent = ({
  id,
  chapters,
  userType,
  enrollmentID,
  courseContentStore: { state, setupAccessControls, init },
}) => {
  useEffect(() => {
    ;(async () => {
      await init(id, chapters, userType)
      if (enrollmentID) {
        setupAccessControls(enrollmentID)
      }
    })()
  }, [id, chapters, userType, enrollmentID, init, setupAccessControls])

  return state.loading ? (
    <Loading />
  ) : (
    <div className='courseContent'>
      <Lessons />
    </div>
  )
}

export default withStore([CourseContentStore])(CourseContent)
